<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="full-card">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm">プレビュー</q-toolbar-title>
        <div class="row no-wrap q-gutter-sm">
          <q-btn flat round dense icon="close" v-close-popup />
        </div>
      </q-toolbar>
      <q-card-section style="height: 90vh; display: flex; flex-direction: column">
        <div class="text-h6 text-bold q-mx-sm q-mt-sm">メニューパターン</div>
        <div class="text-subtitle2 q-ml-sm q-mb-sm">
          リッチメニュー内に作成した表示条件別のパターンを選択してください
        </div>
        <q-select
          outlined
          dense
          emit-value
          map-options
          v-model="richMenuContent"
          :options="richMenu.prod_detail?.rich_menu_content"
          class="q-mx-sm q-mb-sm"
        />
        <div class="preview-device--sp row justify-center">
          <div class="preview-device--container" ref="pageChat">
            <div class="full-width flex justify-center">
              <img :src="richMenuContent?.image_url" style="max-width: 100%; object-fit: contain" alt="" />
            </div>
          </div>
          <div class="preview-device--menu">
            <div class="full-height relative-position flex items-center justify-center">
              <q-icon name="keyboard" color="white" size="sm" style="position: absolute; left: 12px" />
              <div class="text-white" style="font-size: 20px">{{ richMenu.prod_detail.chat_bar_text }}</div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang='ts'>
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IRichMenu, IRichMenuContent } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:closeModal'],
})
export default class RichMenuPreviewModal extends Vue {
  @Prop()
  modalVisible!: boolean

  @Prop()
  richMenu!: IRichMenu

  richMenuContent: IRichMenuContent | null = null

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }
}
</script>

<style scoped lang='scss'>
.text-h6 {
  font-size: 16px !important;
}
.text-subtitle2 {
  font-size: 12px;
  font-weight: 400;
  line-height: 17.38px;
}
.preview-device {
  position: relative;
  $root: &;
  &--sp {
    overflow: hidden;
    position: relative;
    background: url('/img/devices/iphone_14.png') no-repeat center;
    background-size: contain;
    margin: auto;
    height: 80%;
    aspect-ratio: 421 / 850;
    top: 8px;
    #{$root} {
      &--container {
        border: 18px solid transparent;
        border-top-width: 50px;
      }
    }

    .preview-device--popup--overlay {
      width: 100%;
    }
  }
  &--container {
    margin: 0 auto;
    overflow: auto;
    width: 100%;
    height: 88%;
    position: relative;
    display: flex;
    align-items: flex-end;
    &:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
    }
  }
  &--menu {
    position: absolute;
    bottom: 2.4%;
    width: 89%;
    height: 12%;
    background: #34425f;
    border-radius: 0 0 28px 28px;
  }
}
</style>
